import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { motion } from 'framer-motion';
export function FinalMessage() {
  return <section className="relative py-32 px-6 overflow-hidden" data-id="element-132">
      {/* Warm Gradient Background */}
      <div className="absolute inset-0 bg-gradient-to-br from-terracotta/90 to-amber/90" data-id="element-133"></div>

      {/* Decorative overlay */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMiIgY3k9IjIiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4xKSIvPjwvc3ZnPg==')] opacity-30" data-id="element-134"></div>

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-135">
        <AnimatedSection data-id="element-136">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-137">
            Tu Historia Merece <br className="hidden md:block" data-id="element-138" />
            <span className="italic font-light" data-id="element-139">Ser Contada</span>
          </h2>
          <p className="text-xl md:text-2xl text-white/90 mb-12 leading-relaxed max-w-2xl mx-auto font-light" data-id="element-140">
            El silencio te protegió en el pasado, pero tu voz te liberará en el
            presente. Da el primer paso hacia la vida plena y auténtica que
            siempre has merecido.
          </p>
          <motion.a href="https://7kaxyn4bz2pgw2pi-97302217014.shopifypreview.com/products_preview?preview_key=7423b83fb7c6725a7ae81fffa389df5e" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="inline-block bg-white text-terracotta px-10 py-5 rounded-full font-bold text-lg shadow-xl hover:bg-cream transition-colors duration-300" data-id="element-141">
            Comenzar mi Sanación
          </motion.a>
        </AnimatedSection>
      </div>
    </section>;
}